import classNames from 'classnames';
import omit from 'lodash.omit';
import PropTypes from 'prop-types';
import React from 'react';
import ActionMenu from '../action-menu/action-menu.jsx';
import Painting from '../action-menu/icon--huihua.svg';
import Sound from '../action-menu/icon--shenyin.svg';
import { defineMessages, FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import tabStyles from 'react-tabs/style/react-tabs.css';
import VM from 'scratch-vm';
import Renderer from 'scratch-render';

import Blocks from '../../containers/blocks.jsx';
import CostumeTab from '../../containers/costume-tab.jsx';
import TargetPane from '../../containers/target-pane.jsx';
import SoundTab from '../../containers/sound-tab.jsx';
import StageWrapper from '../../containers/stage-wrapper.jsx';
import Loader from '../loader/loader.jsx';
import Box from '../box/box.jsx';
import MenuBar from '../menu-bar/menu-bar.jsx';
import CostumeLibrary from '../../containers/costume-library.jsx';
import BackdropLibrary from '../../containers/backdrop-library.jsx';
import Watermark from '../../containers/watermark.jsx';

import Backpack from '../../containers/backpack.jsx';
import PreviewModal from '../../containers/preview-modal.jsx';
import ImportModal from '../../containers/import-modal.jsx';
import WebGlModal from '../../containers/webgl-modal.jsx';
import TipsLibrary from '../../containers/tips-library.jsx';
import Cards from '../../containers/cards.jsx';
import Alerts from '../../containers/alerts.jsx';
import DragLayer from '../../containers/drag-layer.jsx';
import ConnectionModal from '../../containers/connection-modal.jsx';
import TelemetryModal from '../telemetry-modal/telemetry-modal.jsx';
import CodePanel from '../code-panel/code-panel.jsx';
import ScrollButton from '../scroll-button/scroll-button.jsx';
import FeedbackComponent from '../../containers/feedback-page.jsx';
import LoginComponent from '../../containers/login.jsx';
import Robotlibrary from '../robot-library/robot-library.jsx';
import UpdateBox from '../update-box/update-box.jsx';
import Btnlist from '../../containers/btnList.jsx';
import CodeMirrors from '../codemirror/code-mirror.jsx';
import DownloadComponent from '../../containers/donwloadAlert.jsx';
import Feedbackquestion from '../feedback-page/feedback-question.jsx';
import Questionpages from '../feedback-page/questions.jsx';
import StormLink from '../alerts/stormOs-link.jsx';
import LinkTab from '../linkTab/linkTab.jsx';

import layout, { STAGE_SIZE_MODES } from '../../lib/layout-constants';
import { resolveStageSize } from '../../lib/screen-utils';

import styles from './gui.css';

import role from './icon-role.png';
import stageclose from './icon-stageClose.png';
import robot from './icon-robot.png';
import background from './icon-background.png';
import closes from './icon--close.svg';//声音跟绘画的关闭图标

import { STAGE_DISPLAY_SIZES } from '../../lib/layout-constants.js';
import StageHeader from '../../containers/stage-header.jsx';
import Upload_E7 from '../uploadE7/upload_E7.jsx';

const messages = defineMessages({
    addExtension: {
        id: 'gui.gui.addExtension',
        description: 'Button to add an extension in the target pane',
        defaultMessage: 'Add Extension'
    },
    switchBackground: {
        id: 'gui.spriteSelector.switchBackground',
        description: 'Button to add a stage in the target pane from library',
        defaultMessage: 'switch a Background'
    },
    switchSound: {
        id: 'gui.spriteSelector.switchSound',
        description: 'Button to add a stage in the target pane from library',
        defaultMessage: 'switch a Sound'
    }
});

// python代码编译判断
const robotArray = [
    ['role', 'bg', 'E6', 'M6', 'E7', 'STORM_OS', 'M5',"C6"],
    ['role', 'bg', 'E6', 'M6', 'C1', 'A2', 'E3', "C6"]
];

// 下拉是否出现python按钮判断
const downArray = ['role', 'bg', 'E6', 'M6', 'E7', 'STORM_OS', 'M5'];

// Cache this value to only retrieve it once the first time.
// Assume that it doesn't change for a session.
let isRendererSupported = null;

const GUIComponent = props => {
    const {
        accountNavOpen,
        activeTabIndex,
        alertsVisible,
        authorId,
        authorThumbnailUrl,
        authorUsername,
        basePath,
        backdropLibraryVisible,
        backpackHost,
        backpackVisible,
        blocksTabVisible,
        cardsVisible,
        canCreateNew,
        canEditTitle,
        canRemix,
        canSave,
        canCreateCopy,
        canShare,
        canUseCloud,
        children,
        className,
        connectionModalVisible,
        costumeLibraryVisible,
        costumesTabVisible,
        enableCommunity,
        importInfoVisible,
        intl,
        isCreating,
        isPlayerOnly,
        isRtl,
        isShared,
        loading,
        renderLogin,
        onClickAccountNav,
        onCloseAccountNav,
        onLogOut,
        onOpenRegistration,
        onToggleLoginOpen,
        onUpdateProjectTitle,
        onActivateCostumesTab,
        onActivateSoundsTab,
        onActivateTab,
        onInitDebugStatus,
        onSetActiveId,
        onSetCloseStatus,
        onClickLogo,
        onExtensionButtonClick,
        onRequestCloseBackdropLibrary,
        onRequestCloseCostumeLibrary,
        onRequestCloseTelemetryModal,
        onSeeCommunity,
        onShare,
        onTelemetryModalCancel,
        onTelemetryModalOptIn,
        onTelemetryModalOptOut,
        previewInfoVisible,
        showComingSoon,
        soundsTabVisible,
        stageSizeMode,
        targetIsStage,
        telemetryModalVisible,
        tipsLibraryVisible,
        vm,
        active,
        downloadCCode,
        debug,
        onActiveItemOne,
        onActiveItemTwo,
        onActiveItemThree,
        showHideStage,
        close,
        closePanel,
        onChangeWidth,
        onChangeCode,
        stageSize,
        blockClose,
        roledate,
        isClose,
        downloadBtnBoxClose,
        downloadBtnBoxClick,

        isLogout,
        downloadC,
        btnhide,
        btnTrue,
        btnFalse,
        showtitle,
        tabsActiveIndex,
        clickToBlockpanel,
        clickToEditpanel,
        signOut,
        turbo,
        isfeedback,
        islogin,
        closeRobotLibrary,
        onNewRobotClick,
        CloseLibrary,
        openLibrary,
        robotItemActive,
        robotActive,
        link,
        bubble,
        hasUpdate,
        setStateTrue,
        setStateFalse,
        isUpdateBox,
        updateProgress,
        setupdateProgress,
        version,
        handleSetVersion,
        softwareVersion,
        openShowTitle,
        closeShowTitle,
        onSetShowStatus,
        showStage,
        showMenuStage,
        downloadConfig,
        downloadset,
        setRunningStatus,
        history,
        questions,
        onhandleClickHideLoading,
        showStormOslink,
        linkTab,
        monacodeValue,
        setMonaCodeValue,
        projectTitle,
        isUploadE7,
        onUpdateReduxProjectTitle,
        ...componentProps
    } = omit(props, 'dispatch');

    if (children) {
        return <Box {...componentProps}>{children}</Box>;
    }

    const tabClassNames = {
        tabs: styles.tabs,
        tab: classNames(tabStyles.reactTabsTab, styles.tab),
        tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
        tabLists: classNames(tabStyles.reactTabsTabList, styles.tabLists),
        tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
        tabActive: classNames(styles.active),
        tabPanelSelected: classNames(tabStyles.reactTabsTabPanelSelected, styles.isSelected),
        tabSelected: classNames(tabStyles.reactTabsTabSelected, styles.isSelected)
    };

    if (isRendererSupported === null) {
        isRendererSupported = Renderer.isSupported();
    }

    const clickOne = function () {
        setStateFalse('showStage')
        btnFalse();
        setTimeout(() => {
            const targets = vm.runtime.targets.filter(target => target.isRobot || target.isStage)
            const robotArray = []
            vm.runtime.targets.filter(target => { if (target.isRobot) { return target.id } }).forEach(element => {
                robotArray.push(element.id)
            });
            const defaultRobot = vm.runtime.defaultOptions.defaultRobot
            if (targets.length == 1) {
                vm.setEditingTarget(targets[0].id)
                vm.setBgEditingTarget(targets[0])
            } else {
                if (vm.editingTarget.isRobot) {
                    vm.setEditingTarget(vm.editingTarget.id)
                } else {
                    if (defaultRobot) {
                        if (robotArray.indexOf(defaultRobot) == -1) {
                            vm.setEditingTarget(targets[1].id)
                        } else {
                            vm.setEditingTarget(defaultRobot)
                        }
                    } else {
                        vm.setEditingTarget(targets[1].id)
                    }
                }
            }
            onActiveItemOne();
            // window.dispatchEvent(new Event('resize'));
        }, 0);
    };
    const clickTwo = function () {
        setStateTrue('showStage')
        btnTrue();
        setTimeout(() => {
            const targets = vm.runtime.targets.filter(target => !target.isRobot)
            const defaultRole = vm.runtime.defaultOptions.defaultRole
            if (targets.length == 1) {
                vm.setEditingTarget(targets[0].id)
                vm.setBgEditingTarget(targets[0])
            } else {
                if (
                    vm.editingTarget.isStage ||
                    !vm.editingTarget.isStage && vm.editingTarget.isRobot) {
                    const editing = vm.runtime.targets.filter(target => target.id == defaultRole)
                    if (defaultRole && editing.length != 0) {
                        vm.setEditingTarget(defaultRole)
                    } else {
                        vm.setEditingTarget(targets[1].id)
                    }
                } else {
                    vm.setEditingTarget(vm.editingTarget.id)
                }
            }
            onActiveItemTwo();
            // window.dispatchEvent(new Event('resize'));
        }, 0);
    };
    const clickThree = function () {
        setStateTrue('showStage')
        btnTrue();
        setTimeout(() => {
            const targets = vm.runtime.targets.filter(target => !target.isRobot && target.isStage)
            vm.setEditingTarget(targets[0].id)
            onActiveItemThree();
            // window.dispatchEvent(new Event('resize'));
        }, 0);
    };
    if (!loading && !isCreating) {
        onhandleClickHideLoading && onhandleClickHideLoading()
    }
    return (<MediaQuery minWidth={layout.fullSizeMinWidth}>{isFullSize => {
        const stageSize = resolveStageSize(stageSizeMode, isFullSize);
        const defaultType = vm.robotType ? vm.robotType : "E6" //默认robotType为E6
        return isPlayerOnly ? (
            <StageWrapper
                isRendererSupported={isRendererSupported}
                isRtl={isRtl}
                loading={loading}
                stageSize={STAGE_SIZE_MODES.large}
                vm={vm}
            >
                {alertsVisible ? (
                    <Alerts className={styles.alertsContainer} />
                ) : null}
            </StageWrapper>
        ) : (
            <Box
                className={styles.pageWrapper}
                dir={isRtl ? 'rtl' : 'ltr'}
                {...componentProps}
            >
                {/* {previewInfoVisible ? (
                <PreviewModal />
            ) : null} */}
                {/* {telemetryModalVisible ? (
                    <TelemetryModal
                        onCancel={onTelemetryModalCancel}
                        onOptIn={onTelemetryModalOptIn}
                        onOptOut={onTelemetryModalOptOut}
                        onRequestClose={onRequestCloseTelemetryModal}
                    />
                ) : null} */}
                {loading ? (
                    <Loader />
                ) : null}
                {isCreating ? (
                    <Loader messageId="gui.loader.creating" />
                ) : null}
                {importInfoVisible ? (
                    <ImportModal />
                ) : null}
                {/* {isRendererSupported ? null : (
                        <WebGlModal isRtl={isRtl} />
                    )} */}
                {tipsLibraryVisible ? (
                    <TipsLibrary
                        setStateTrue={setStateTrue}
                        setStateFalse={setStateFalse}
                        clickToBlockpanel={clickToBlockpanel}
                    />
                ) : null}
                {isfeedback ? (
                    <FeedbackComponent
                        intl={intl}
                        setupdateProgress={setupdateProgress}
                        setStateTrue={setStateTrue}
                        setStateFalse={setStateFalse}
                    />
                ) : null}
                {questions.showquestion ? <Feedbackquestion /> : null}
                {history.length != 0 ? <Questionpages /> : null}
                {islogin ? (
                    <LoginComponent
                        intl={intl}
                    />
                ) : null}
                {cardsVisible ? (
                    <Cards />
                ) : null}
                {alertsVisible ? (
                    <Alerts className={styles.alertsContainer} />
                ) : null}
                {connectionModalVisible ? (
                    <ConnectionModal
                        vm={vm}
                    />
                ) : null}
                {costumeLibraryVisible ? (
                    <CostumeLibrary
                        vm={vm}
                        onRequestClose={onRequestCloseCostumeLibrary}
                    />
                ) : null}
                {backdropLibraryVisible ? (
                    <BackdropLibrary
                        vm={vm}
                        onRequestClose={onRequestCloseBackdropLibrary}
                    />
                ) : null}
                {closeRobotLibrary ? null : (
                    <Robotlibrary
                        CloseLibrary={CloseLibrary}
                        openLibrary={openLibrary}
                        robotItemActive={robotItemActive}
                        robotActive={robotActive}
                        intl={intl}
                    />
                )}
                {/* isUpdateBox */}
                <UpdateBox
                    setStateFalse={setStateFalse}
                    updateProgress={updateProgress}
                    link={link}
                    setupdateProgress={setupdateProgress}
                    version={version}
                    softwareVersion={softwareVersion}
                    intl={intl}
                    isUpdateBox={isUpdateBox}
                    vm={vm}
                />
                {
                    isUploadE7 ? <Upload_E7 /> : null
                }
                {downloadConfig.show ? (<DownloadComponent
                    intl={intl}
                />) : null}
                {showStormOslink ? <StormLink
                    vm={vm}
                /> : null}
                <LinkTab
                    vm={vm}
                    linkTab={linkTab}
                />
                <MenuBar
                    accountNavOpen={accountNavOpen}
                    authorId={authorId}
                    authorThumbnailUrl={authorThumbnailUrl}
                    authorUsername={authorUsername}
                    canCreateCopy={canCreateCopy}
                    canCreateNew={canCreateNew}
                    canEditTitle={canEditTitle}
                    canRemix={canRemix}
                    canSave={canSave}
                    canShare={canShare}
                    className={styles.menuBarPosition}
                    enableCommunity={enableCommunity}
                    isShared={isShared}
                    renderLogin={renderLogin}
                    showComingSoon={showComingSoon}
                    onClickAccountNav={onClickAccountNav}
                    onClickLogo={onClickLogo}
                    onCloseAccountNav={onCloseAccountNav}
                    onLogOut={onLogOut}
                    onOpenRegistration={onOpenRegistration}
                    onSeeCommunity={onSeeCommunity}
                    onShare={onShare}
                    onToggleLoginOpen={onToggleLoginOpen}
                    onUpdateProjectTitle={onUpdateProjectTitle}
                    blockClose={blockClose}
                    isClose={isClose}
                    robotType={vm.robotType}
                    downArray={downArray}
                    showtitle={showtitle}
                    clickToBlockpanel={clickToBlockpanel}
                    clickToEditpanel={clickToEditpanel}
                    signOut={signOut}
                    isLogout={isLogout}
                    bubble={bubble}
                    hasUpdate={hasUpdate}
                    setStateTrue={setStateTrue}
                    setStateFalse={setStateFalse}
                    link={link}
                    setupdateProgress={setupdateProgress}
                    handleSetVersion={handleSetVersion}
                    version={version}
                    setMonaCodeValue={setMonaCodeValue}
                    vm={vm}
                />
                <Box className={styles.bodyWrapper}>
                    <CodeMirrors
                        vm={vm}
                        intl={intl}
                        monacodeValue={monacodeValue}
                        setMonaCodeValue={setMonaCodeValue}
                        projectTitle={projectTitle}
                        showtitle={showtitle}
                    />
                    <Box className={styles.flexWrapper}>
                        <Box className={styles.editorWrapper}>
                            <div
                                className={tabClassNames.tabLists}
                            >
                                <div
                                    className={classNames(tabClassNames.tab, { [styles.isSelected]: tabsActiveIndex == 0 })}
                                    onClick={clickOne}
                                >
                                    <img
                                        draggable={false}
                                        src={robot}
                                    />
                                    <FormattedMessage
                                        defaultMessage="robot"
                                        description="Button to get to the Robot panel"
                                        id="gui.gui.robotTab"
                                    />
                                </div>
                                <div
                                    className={classNames(tabClassNames.tab, { [styles.isSelected]: tabsActiveIndex == 1 })}
                                    onClick={clickTwo}
                                >
                                    <img
                                        draggable={false}
                                        src={role}
                                    />
                                    <FormattedMessage
                                        defaultMessage="Role"
                                        description="Button to get to the role panel"
                                        id="gui.gui.roleTab"
                                    />
                                </div>
                                <div
                                    className={classNames(tabClassNames.tab, { [styles.isSelected]: tabsActiveIndex == 2 })}
                                    onClick={clickThree}
                                >
                                    <img
                                        draggable={false}
                                        src={background}
                                    />
                                    <FormattedMessage
                                        defaultMessage="background"
                                        description="Button to get to the background panel"
                                        id="gui.gui.backgroundTab"
                                    />
                                </div>
                            </div>
                            <div className={classNames(styles.tabList2, className)}>
                                {/* 添加一个名为downloadBtnBoxClose的props，将下载按钮列表的状态传递下去 */}
                                <Btnlist
                                    defaultType={defaultType}
                                    vm={vm}
                                    downloadBtnBoxClose={downloadBtnBoxClose}
                                    downloadBtnBoxClick={downloadBtnBoxClick}
                                />

                            </div>
                            {/* <Box className={classNames(styles.stageBtnTab, styles[stageSize],{[styles.showStage]:!showStage})}> */}
                            <Box className={classNames(styles.stageBtnTab, styles[stageSize])}>
                                <StageHeader
                                    stageSize={stageSize}
                                    showStage={showStage}
                                    vm={vm}
                                />
                            </Box>
                            <Box className={classNames(styles.scrollButton,
                                styles[stageSize],
                                { [styles.hideButton]: tabsActiveIndex == 0 }
                            )}>
                                <div className={classNames(styles.buttonTip, { [styles.titles]: turbo })}>
                                    {/* <span>{JSON.stringify(turbo)}</span> */}
                                    <FormattedMessage
                                        defaultMessage="Turbo Mode"
                                        description="Label indicating turbo mode is active"
                                        id="gui.turboMode.active"
                                    />
                                </div>
                                <ScrollButton
                                    vm={vm}
                                    turbo={turbo}
                                />
                            </Box>
                            <Box
                                className={classNames(
                                    styles.stageBtn,
                                    styles[stageSize],
                                    // {[styles.stageBtnShowStage]:!showStage},
                                    { [styles.stageBtnCloseStage]: stageSize === 'closeStatus' }
                                )}
                                onClick={showHideStage}
                            >
                                <img
                                    src={stageclose}
                                />


                            </Box>
                            <Tabs
                                forceRenderTabPanel
                                className={tabClassNames.tabs}
                                selectedIndex={activeTabIndex}
                                selectedTabClassName={tabClassNames.tabSelected}
                                selectedTabPanelClassName={tabClassNames.tabPanelSelected}
                                onSelect={onActivateTab}
                            >


                                <TabList style={{ display: 'none' }}>
                                    <Tab>1</Tab>
                                    <Tab>2</Tab>
                                    <Tab>3</Tab>
                                </TabList>

                                <TabPanel className={tabClassNames.tabPanel}>
                                    <Box className={styles.blocksWrapper}>
                                        <Blocks
                                            canUseCloud={canUseCloud}
                                            grow={1}
                                            isVisible={blocksTabVisible}
                                            options={{
                                                media: `${basePath}static/blocks-media/`
                                            }}
                                            stageSize={stageSize}
                                            clickOne={clickOne}
                                            vm={vm}
                                        />
                                    </Box>
                                    {/* <Box className={styles.extensionButtonContainer}>
                                        <button
                                            className={styles.extensionButton}
                                            title={intl.formatMessage(messages.addExtension)}
                                            onClick={onExtensionButtonClick}
                                        >
                                            <img
                                                className={styles.extensionButtonIcon}
                                                draggable={false}
                                                src={addExtensionIcon}
                                            />
                                        </button>
                                    </Box> */}
                                    <Box className={styles.watermark}>
                                        <Watermark />
                                    </Box>

                                </TabPanel>
                                <TabPanel className={tabClassNames.tabPanel}>
                                    {costumesTabVisible ? <CostumeTab vm={vm} /> : null}
                                </TabPanel>
                                <TabPanel className={tabClassNames.tabPanel}>
                                    {soundsTabVisible ? <SoundTab vm={vm} /> : null}
                                </TabPanel>

                            </Tabs>
                            {/* {backpackVisible ? (
                            <Backpack host={backpackHost} />
                        ) : null} */}

                        </Box>

                        <Box
                            className={classNames(styles.stageAndTargetWrapper,
                                { [styles.stageAndTargetWrapperShow]: stageSize === 'closeStatus' }, styles[stageSize])}
                        // style={showStage}
                        >

                            {/* <Tabs
                            forceRenderTabPanel
                            selectedIndex={activeTabIndex}
                            selectedTabClassName={tabClassNames.tabSelected}
                            selectedTabPanelClassName={tabClassNames.tabPanelSelected}
                            onSelect={onActivateTab}
                        >
                        <TabList className={tabClassNames.tabList}>
                            <Tab className={tabClassNames.tab}>
                                <img
                                    draggable={false}
                                    src={codeIcon}
                                />
                                <FormattedMessage
                                    defaultMessage="Code"
                                    description="Button to get to the code panel"
                                    id="gui.gui.codeTab"
                                />
                            </Tab>
                            <Tab
                                className={tabClassNames.tab}
                                onClick={onActivateCostumesTab}
                            >
                                <img
                                    draggable={false}
                                    src={costumesIcon}
                                />
                                {targetIsStage ? (
                                    <FormattedMessage
                                        defaultMessage="Backdrops"
                                        description="Button to get to the backdrops panel"
                                        id="gui.gui.backdropsTab"
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Costumes"
                                        description="Button to get to the costumes panel"
                                        id="gui.gui.costumesTab"
                                    />
                                )}
                            </Tab>
                            <Tab
                                className={tabClassNames.tab}
                                onClick={onActivateSoundsTab}
                            >
                                <img
                                    draggable={false}
                                    src={soundsIcon}
                                />
                                <FormattedMessage
                                    defaultMessage="Sounds"
                                    description="Button to get to the sounds panel"
                                    id="gui.gui.soundsTab"
                                />
                            </Tab>
                        </TabList>
                        </Tabs>  */}
                            <StageWrapper
                                isRendererSupported={isRendererSupported}
                                stageSize={stageSize}
                                btnFalse={btnTrue}
                                showStage={showStage}
                                isRtl={isRtl}
                                vm={vm}
                            />
                            {/* <Box className={classNames(styles.targetWrapper,{[styles.targetWrapperStage]:!showStage})}> */}
                            <Box className={classNames(styles.targetWrapper)}>
                                <TargetPane
                                    stageSize={stageSize}
                                    onNewRobotClick={onNewRobotClick}
                                    clickToBlockpanel={clickToBlockpanel}
                                    link={link}
                                    intl={intl}
                                    isRtl={isRtl}
                                    vm={vm}
                                />
                            </Box>
                            <div
                                className={classNames(styles.addButtonBox, { [styles.btnHides]: !btnhide })}
                            >
                                <ActionMenu
                                    className={classNames(styles.addButtonTwo)}
                                    img={showMenuStage == 'block' ? Painting : showMenuStage == 'costumes' ? closes : Painting}
                                    title={intl.formatMessage(messages.switchBackground)}
                                    onClick={onActivateCostumesTab}
                                    tooltipPlace={isRtl ? "right" : "left"}

                                />
                                <ActionMenu
                                    className={classNames(styles.addButtonThree)}
                                    img={showMenuStage == 'block' ? Sound : showMenuStage == 'sounds' ? closes : Sound}
                                    title={intl.formatMessage(messages.switchSound)}
                                    onClick={onActivateSoundsTab}
                                    tooltipPlace={isRtl ? "right" : "left"}
                                />
                            </div>
                        </Box>
                        <div style={{ position: 'relative' }}>
                            <CodePanel
                                className={classNames(styles.codepanel)}
                                onChangeCode={onChangeCode}
                                onClick={closePanel}
                                changeWidth={onChangeWidth}
                                robotType={vm.robotType}
                                robotArray={robotArray}
                                isRtl={isRtl}
                            />
                        </div>

                    </Box>

                </Box>
            </Box>
        );
    }}</MediaQuery>);
};

GUIComponent.propTypes = {
    accountNavOpen: PropTypes.bool,
    active: PropTypes.bool,
    activeTabIndex: PropTypes.number,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // can be false
    authorThumbnailUrl: PropTypes.string,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // can be false
    backdropLibraryVisible: PropTypes.bool,
    backpackHost: PropTypes.string,
    backpackVisible: PropTypes.bool,
    basePath: PropTypes.string,
    blocksTabVisible: PropTypes.bool,
    canCreateCopy: PropTypes.bool,
    canCreateNew: PropTypes.bool,
    canEditTitle: PropTypes.bool,
    canRemix: PropTypes.bool,
    canSave: PropTypes.bool,
    canShare: PropTypes.bool,
    canUseCloud: PropTypes.bool,
    cardsVisible: PropTypes.bool,
    children: PropTypes.node,
    className: PropTypes.string,
    costumeLibraryVisible: PropTypes.bool,
    costumesTabVisible: PropTypes.bool,
    downloadCCode: PropTypes.func,
    enableCommunity: PropTypes.bool,
    importInfoVisible: PropTypes.bool,
    intl: intlShape.isRequired,
    isCreating: PropTypes.bool,
    isPlayerOnly: PropTypes.bool,
    isRtl: PropTypes.bool,
    isShared: PropTypes.bool,
    loading: PropTypes.bool,
    onActivateCostumesTab: PropTypes.func,
    onActivateSoundsTab: PropTypes.func,
    onActivateTab: PropTypes.func,
    onActiveItemOne: PropTypes.func,
    onActiveItemThree: PropTypes.func,
    onActiveItemTwo: PropTypes.func,
    closePanel: PropTypes.func.isRequired,
    onChangeWidth: PropTypes.func.isRequired,
    onChangeCode: PropTypes.func.isRequired,
    showHideStage: PropTypes.func,
    onClickAccountNav: PropTypes.func,
    onClickLogo: PropTypes.func,
    onCloseAccountNav: PropTypes.func,
    onExtensionButtonClick: PropTypes.func,
    onLogOut: PropTypes.func,
    onOpenRegistration: PropTypes.func,
    onRequestCloseBackdropLibrary: PropTypes.func,
    onRequestCloseCostumeLibrary: PropTypes.func,
    onRequestCloseTelemetryModal: PropTypes.func,
    onSeeCommunity: PropTypes.func,
    onShare: PropTypes.func,
    onTabSelect: PropTypes.func,
    onTelemetryModalCancel: PropTypes.func,
    onTelemetryModalOptIn: PropTypes.func,
    onTelemetryModalOptOut: PropTypes.func,
    onToggleLoginOpen: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    previewInfoVisible: PropTypes.bool,
    renderLogin: PropTypes.func,
    showComingSoon: PropTypes.bool,
    soundsTabVisible: PropTypes.bool,
    stageSizeMode: PropTypes.oneOf(Object.keys(STAGE_SIZE_MODES)),
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    targetIsStage: PropTypes.bool,
    telemetryModalVisible: PropTypes.bool,
    tipsLibraryVisible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
    isfeedback: PropTypes.bool,
    islogin: PropTypes.bool,
};
GUIComponent.defaultProps = {
    active: false,
    backpackHost: null,
    backpackVisible: false,
    basePath: './',
    canCreateNew: false,
    canEditTitle: false,
    canRemix: false,
    canSave: false,
    canCreateCopy: false,
    canShare: false,
    canUseCloud: false,
    enableCommunity: false,
    isCreating: false,
    isShared: false,
    loading: false,
    onUpdateProjectTitle: () => { },
    showComingSoon: false,
    stageSizeMode: STAGE_SIZE_MODES.small,
    stageSize: STAGE_SIZE_MODES.small
};

const mapStateToProps = state => ({
    // This is the button's mode, as opposed to the actual current state
    stageSizeMode: state.scratchGui.stageSize.stageSize
});

export default injectIntl(connect(
    mapStateToProps
)(GUIComponent));
